import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class UpdateCart extends Event {
    eventName = 'oms_updateCart';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for update cart
     * 
     * @param {string} data.item -  product item
     * @param {string} data.id -  product id		
     * @param {string} data.count - optional - number of items (default 1)
     * @param {string} data.action - optional - request action - values : add/reduce/delete/deleteAll
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let item = data.item;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let id = data.id;
        let count = data.count ? data.count : 1;
        let flash_order = (data.flash_order) ? data.flash_order : false;
        let thisObj = this;
        
        if (clientId && action) {
            let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();
            let cartLocation = new LocalStorage.CartLocation(currentLocation);
            let selectedProducts = cartLocation.getData();
            let cartUpdated = false;
            let baseUrl = window.location.origin;
            let defaultImage = baseUrl + '/public-ui-resources/images/empty-state.png';

            if (action == 'add') {
                let itemImg = (item.images && item.images[0] && item.images[0]["thumb_path"]) ? item.images[0]["thumb_path"] : defaultImage;
                let itemUrl = (item["url_key"]) ? item["url_key"] : (item["seo_url"]) ? item["seo_url"] : '#';
                
                if (selectedProducts && selectedProducts[id]) {
                    let displayPrice = (item.display_price) ? item.display_price : item.item_display_price;
                    selectedProducts[id].item_id = id;
                    selectedProducts[id].item_qty += count;
                    selectedProducts[id].item_name = item["name"];
                    selectedProducts[id].buy_now = item["available_now"];
                    
                    if (item["attributes"]) {
                        let superAttributes = thisObj.getSuperAttributes(item["attributes"]);

                        if (superAttributes.length > 0) {
                            selectedProducts[id].item_attributes = superAttributes;
                        }
                    }
                }
                else {
                    var newItem = {
                      item_id: id,
                      item_qty: count,
                      item_image: itemImg,
                      item_name: item["name"],
                      item_sku: item["code"],
                      item_weight: item["attributes"]["WEIGHT"]
                        ? item["attributes"]["WEIGHT"].value
                        : "",
                      item_price: Number(item["unit_price"]),
                      buy_now: item["available_now"],
                      selected: true,
                      item_msrp_price: item["attributes"]["MSRP"]
                        ? item["attributes"]["MSRP"]["value"]
                        : "",
                      item_display_price: Number(item["display_price"]),
                      item_initial_price: Number(item["unit_price"]),
                      url_key: itemUrl,
                      flash_order: flash_order,
                      item_discount_price: item["display_price"],
                      discount_price: Number(item["display_price"]),
                      item_preparation_time: item["attributes"]["PREPARATION_TIME"]
                        ? item["attributes"]["PREPARATION_TIME"]["value"]
                        : "",
                    };

                    if (item["attributes"]) {
                        let superAttributes = thisObj.getSuperAttributes(item["attributes"]);

                        if (superAttributes.length > 0) {
                            newItem.item_attributes = superAttributes;
                        }
                    }

                    if (selectedProducts == null) {
                        selectedProducts = {};
                    }
                    selectedProducts[id] = newItem;
                }

                new LocalStorage.CartLocation(currentLocation).setData(selectedProducts);
                cartUpdated = true;
            }
            else if (action == 'reduce') {
                if (selectedProducts && selectedProducts[id]) {
                    selectedProducts[id].item_qty -= count;
                    selectedProducts[id].item_id = id;

                    if (selectedProducts[id].item_qty == 0) {
                         delete selectedProducts[id];
                    }
                }

                new LocalStorage.CartLocation(currentLocation).setData(selectedProducts);
                cartUpdated = true;
            }
            else if (action == 'delete') {
                if (selectedProducts && selectedProducts[id]) {
                    selectedProducts[id].item_id = id;
                    delete selectedProducts[id];
                }
                else if (selectedProducts) {
                    Object.keys(selectedProducts).forEach(function (key) {
                        if (key != id && selectedProducts[key] && selectedProducts[key].item_id == id) {
                            selectedProducts[key].item_id = key;
                        }
                    });
                }

                new LocalStorage.CartLocation(currentLocation).setData(selectedProducts);
                cartUpdated = true;
            }
            else if (action == 'deleteAll') {
                new LocalStorage.CartLocation(currentLocation).setData({});
                cartUpdated = true;
            }

            if (cartUpdated) {

                this.onSuccessEvent({
                    "action": action,
                    "data": selectedProducts
                }, {
                    'action' : action, 
                    'request_id' : requestId 
                });
            }

        } else {
            //fire error event
            this.onErrorEvent({ "message": "client_id & action is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }

    getSuperAttributes(attributes) {
        let superAttributes = [];

        for (const attr in attributes) {

            if (attributes[attr].is_super_attribute == "1") {

                superAttributes.push({
                    "attribute_id": attributes[attr].id,
                    "label": attributes[attr].label,
                    "image": attributes[attr].image,
                    "value": attributes[attr].value
                })
            }

        }

        return superAttributes;
    }
}

export default UpdateCart;